import widgetTypes from './widgetType';
import {defaultWidgetsConfig} from './defaultWidgetsConfig';

import {lazy} from "react";

// Cache lazy components by source filename so repeated calls to
// registerWidgets reuse the same React component reference. Creating a fresh
// `lazy()` on every render makes React unmount/remount the entire widget
// subtree (and flash the Suspense placeholder) — visible as a blink whenever
// the dashboard re-renders or widgets are reordered.
const lazyComponentCache = {};

const getLazyComponent = (componentName) => {
    if (!lazyComponentCache[componentName]) {
        lazyComponentCache[componentName] = lazy(() => import(`../components/${componentName}.js`));
    }
    return lazyComponentCache[componentName];
};

export const registerWidgets = (data) => {
    const widgetData = Array.isArray(data) && data.length > 0 ? data : defaultWidgetsConfig;
    for (const widget of widgetData) {
       widgetTypes.registerType({
                type: widget.type,
                kind: widget.kind,
                component: getLazyComponent(widget.component)
      })
    }
};

/**
 * Dashboard config from GET /api/dashboard/config is often { userSchema: WidgetDef[] }.
 * Fall back to defaultWidgetsConfig when data is missing, the wrapper has no
 * userSchema array, or the saved schema is empty (e.g. fresh staging users).
 * Without this fallback the dashboard renders blank with no error.
 */
export const getWidgetDefinitionsFromConfigData = (data) => {
    const candidate = Array.isArray(data)
        ? data
        : (data && Array.isArray(data.userSchema) ? data.userSchema : null);

    if (candidate && candidate.length > 0) {
        registerWidgets(candidate);
        return candidate;
    }

    registerWidgets(defaultWidgetsConfig);
    return defaultWidgetsConfig;
};
